import { useRef } from 'react';
import { isString } from 'lodash';

export const usePrevious = <T>(value: T) => {
  const prevRef = useRef<T>();
  const curRef = useRef<T>();
  const stringifiedValue = isString(value) ? value : JSON.stringify(value);
  const stringifiedCurrent = isString(curRef.current) ? curRef.current : JSON.stringify(curRef.current);

  if (stringifiedValue !== stringifiedCurrent) {
    prevRef.current = curRef.current;
    curRef.current = value;
  }

  return prevRef.current;
};
